import { useState, useEffect, useRef } from "react";
import Error from "../error";
import Label from "./lable";
import "./style.css";

const InputTimeIso = ({ s, v, e, setValue }) => {
	const chg = (t) => {
		if (!t || !t.includes(":")) return t || "";
		const [h, m] = t.split(":");
		const date = new Date();
		date.setUTCHours(parseInt(h), parseInt(m), 0, 0);
		return date.getHours().toString().padStart(2, "0") + ":" + date.getMinutes().toString().padStart(2, "0");
	};
	const [val, setVal] = useState(chg(v));
	const [error, setError] = useState(e ?? []);
	const [shErr, setErr] = useState(false);

	const isFocused = useRef(false);

	useEffect(() => {
		if (val !== v) {
			setVal(chg(v));
		}
	}, [v, val]);

	const { name, id, disabled = false, onChange, onClick, width, style = {}, type = "text" } = s;
	const inputStyle = { ...style?.input, width: width || style?.input?.width };

	return (
		<div className="skin-input-base input-base input-time" style={style?.input_base}>
			<Label label={s?.label} />
			<div className="time">
				<input
					style={inputStyle}
					id={id}
					type={"time"}
					name={name}
					value={val}
					disabled={disabled}
					onFocus={() => {
						isFocused.current = true;
					}}
					onBlur={() => {
						isFocused.current = false;
					}}
					onChange={handleChange}
					onClick={handleClick}
				/>
			</div>
			{shErr && error.length > 0 && <Error err={error} style={style?.error} errHandleClick={() => setErr(false)} />}
		</div>
	);

	function handleChange(e) {
		const newValue = e.target.value;
		setVal(newValue);
		setError([]);

		if (onChange) onChange(e.target);
		if (setValue) {
			setValue(name, newValue, type);
		}
	}

	function handleClick(e) {
		if (error.length !== 0 && !shErr) setErr(true);
		if (onClick) onClick(e.target);
	}
};

export default InputTimeIso;
